<template>
    <div class="filter-with-without-type">
        <div>
            <!-- RADIO : mode => mode -->
            <template v-for="option in optionsMode" :key="option.value">
                <div class="form-group">
                    <label class="form-label label-auto" :for="'opt-' + option.value">
                        <input
                            :id="'opt-' + option.value"
                            v-model="mode"
                            type="radio"
                            name="options"
                            :value="option.value"
                        />
                        {{ option.label }}
                    </label>
                </div>
            </template>

            <!-- SELECT : choice => type -->
            <template v-if="hasMultipleType" class="form-group">
                <h4 v-html="filter.inputs.type.label"></h4>
                <el-select
                    v-model="choice"
                    :class="`wp-10 ` + { 'is-disabled-input': isActive }"
                    :disabled="isActive"
                    filterable
                    :multiple="filter.inputs.type.multiple"
                >
                    <el-option
                        v-for="option in optionsType"
                        :key="'opt-type-' + option.label"
                        :label="option.label"
                        :value="option.value"
                    >
                        {{ option.label }}
                    </el-option>
                </el-select>
            </template>

            <!-- SELECT : subChoices => statuses -->
            <template class="form-group">
                <h4 v-html="filter.inputs.statuses.label"></h4>
                <el-cascader
                    v-model="subChoices"
                    :class="`wp-10 ` + { 'is-disabled-input': isActive }"
                    :disabled="isActive || !choice"
                    popperClass="custom-dropdown"
                    :visibleArrow="false"
                    :props="propsOpt(filter.inputs.statuses)"
                    :options="optionsStatuses(choice)"
                />
            </template>
        </div>
    </div>
</template>
<script>
import ListingFilterMixin from './ListingFilterMixin.js';

export default {
    mixins: [ListingFilterMixin],
    props: {
        filter: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            mode: '',
            choice: '',
            subChoices: [],
        };
    },
    computed: {
        data() {
            return {
                mode: this.mode,
                choice: this.choice,
                subChoices: this.formatSubChoices,
            };
        },

        formatSubChoices() {
            const choices = [];
            this.subChoices.forEach((choice) => {
                choice = Array.isArray(choice) ? choice[0] : choice;
                choices.push(choice);
            });
            return choices;
        },

        /**
         * If "with"
         */
        isActive() {
            return this.mode !== 'with';
        },
        optionsMode() {
            const options = this.filter.inputs.mode.options;
            return Object.values(options);
        },

        /**
         * add value in the options list of "type"
         * return {*}
         */
        optionsType() {
            const options = this.filter.inputs.type.options;
            for (const [name, option] of Object.entries(options)) {
                option.value = name;
            }
            return options;
        },

        /**
         * Define if filter has multiple type. If single, this one is the selected by default
         * return boolean : true if has multiple type else false
         */
        hasMultipleType() {
            const options = Object.keys(this.filter.inputs.type.options);
            if (options.length > 1) {
                return true;
            }
            this.choice = options[0];
            return false;
        },
    },
    watch: {
        choice: function (newChoice, oldChoice) {
            if (newChoice !== oldChoice && oldChoice !== '' && oldChoice !== undefined) {
                this.subChoices = [];
            }
        },
    },
    methods: {
        propsOpt(option) {
            const propOption = {
                multiple: option.multiple ? option.multiple : false,
                filterable: option.filterable ? option.filterable : false,
            };
            return propOption;
        },
        /**
         * put a list only the list of choice of the selected "type"
         * return {*}
         */
        optionsStatuses(choice) {
            const optList = [];

            if (choice) {
                const list = Object.entries(this.filter.inputs.type.options).find(
                    (optChoice) => optChoice[0] === choice,
                );
                for (const [value, label] of Object.entries(list[1].choices)) {
                    optList.push({ value: value, label: label });
                }
            }
            return optList;
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.filter-with-without-type {
    .el-cascader__tags {
        .el-tag.el-tag--info.el-tag--small.el-tag--light {
            color: $gray-100;
            background-color: $primary-05;

            .el-tag__close.el-icon-close {
                background-color: #ccccd1;
            }
        }
    }
}
.el-popper.el-cascader__dropdown.custom-dropdown {
    box-shadow: 0 0 12px rgba(17, 17, 17, 0.24);
    border-radius: 6px;
    margin-top: 4px !important;
    .el-select-dropdown__list {
        padding: 8px 0;

        .el-select-dropdown__item {
            border-radius: 4px;
            margin: 0 8px;
            padding: 0 8px;
        }
    }

    .el-cascader-panel {
        .el-scrollbar.el-cascader-menu .el-cascader-menu__wrap.el-scrollbar__wrap {
            color: $gray-100;
            height: auto;
            .el-cascader-node:hover {
                background: #edf0ff;
            }
        }
    }
}
</style>
